import {useEffect as $5bA4N$useEffect, useRef as $5bA4N$useRef} from "react";
import {useLayoutEffect as $5bA4N$useLayoutEffect, useId as $5bA4N$useId, useSlotId as $5bA4N$useSlotId, focusWithoutScrolling as $5bA4N$focusWithoutScrolling, mergeProps as $5bA4N$mergeProps} from "@react-aria/utils";
import {useLocalizedStringFormatter as $5bA4N$useLocalizedStringFormatter} from "@react-aria/i18n";
import {useHover as $5bA4N$useHover, useFocusWithin as $5bA4N$useFocusWithin, getInteractionModality as $5bA4N$getInteractionModality} from "@react-aria/interactions";
import {useLandmark as $5bA4N$useLandmark} from "@react-aria/landmark";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $7853651519a70071$exports = {};
var $ff9177efc58547ad$exports = {};
$ff9177efc58547ad$exports = {
    "close": `إغلاق`,
    "notifications": `إشعارات`
};


var $25eb7c0c0c45e544$exports = {};
$25eb7c0c0c45e544$exports = {
    "close": `Затвори`,
    "notifications": `Известия`
};


var $28feffc3d61a8691$exports = {};
$28feffc3d61a8691$exports = {
    "close": `Zavřít`,
    "notifications": `Upozornění`
};


var $390d441203d25ff4$exports = {};
$390d441203d25ff4$exports = {
    "close": `Luk`,
    "notifications": `Påmindelser`
};


var $7063c2d0f14f979a$exports = {};
$7063c2d0f14f979a$exports = {
    "close": `Schließen`,
    "notifications": `Benachrichtigungen`
};


var $2dfc1dbb6590af88$exports = {};
$2dfc1dbb6590af88$exports = {
    "close": `Κλείσιμο`,
    "notifications": `Ειδοποιήσεις`
};


var $9a12ff1caae5a7a5$exports = {};
$9a12ff1caae5a7a5$exports = {
    "close": `Close`,
    "notifications": `Notifications`
};


var $f4095fb5a72adbe6$exports = {};
$f4095fb5a72adbe6$exports = {
    "close": `Cerrar`,
    "notifications": `Notificaciones`
};


var $75bc5191b9d7826a$exports = {};
$75bc5191b9d7826a$exports = {
    "close": `Sule`,
    "notifications": `Teated`
};


var $e4b9aef18b0db8dc$exports = {};
$e4b9aef18b0db8dc$exports = {
    "close": `Sulje`,
    "notifications": `Ilmoitukset`
};


var $888756784d832bd7$exports = {};
$888756784d832bd7$exports = {
    "close": `Fermer`,
    "notifications": `Notifications`
};


var $6835949b68a1fabf$exports = {};
$6835949b68a1fabf$exports = {
    "close": `סגור`,
    "notifications": `התראות`
};


var $87ffcbc0b651e40b$exports = {};
$87ffcbc0b651e40b$exports = {
    "close": `Zatvori`,
    "notifications": `Obavijesti`
};


var $dc6e3b2813600d69$exports = {};
$dc6e3b2813600d69$exports = {
    "close": `Bezárás`,
    "notifications": `Értesítések`
};


var $fe136bcbacfcfa14$exports = {};
$fe136bcbacfcfa14$exports = {
    "close": `Chiudi`,
    "notifications": `Notifiche`
};


var $8fb53a929b46df83$exports = {};
$8fb53a929b46df83$exports = {
    "close": `閉じる`,
    "notifications": `通知`
};


var $2c38dbfaf041a865$exports = {};
$2c38dbfaf041a865$exports = {
    "close": `닫기`,
    "notifications": `알림`
};


var $48f3f33a29908d4c$exports = {};
$48f3f33a29908d4c$exports = {
    "close": `Uždaryti`,
    "notifications": `Pranešimai`
};


var $9867160d996455a0$exports = {};
$9867160d996455a0$exports = {
    "close": `Aizvērt`,
    "notifications": `Paziņojumi`
};


var $196258ea25c96487$exports = {};
$196258ea25c96487$exports = {
    "close": `Lukk`,
    "notifications": `Varsler`
};


var $949061cb954e8000$exports = {};
$949061cb954e8000$exports = {
    "close": `Sluiten`,
    "notifications": `Meldingen`
};


var $8189bed27add1ad3$exports = {};
$8189bed27add1ad3$exports = {
    "close": `Zamknij`,
    "notifications": `Powiadomienia`
};


var $a361756a93b6e28c$exports = {};
$a361756a93b6e28c$exports = {
    "close": `Fechar`,
    "notifications": `Notificações`
};


var $034c7393857c8db0$exports = {};
$034c7393857c8db0$exports = {
    "close": `Fechar`,
    "notifications": `Notificações`
};


var $e33d3b3868478b04$exports = {};
$e33d3b3868478b04$exports = {
    "close": `Închideţi`,
    "notifications": `Notificări`
};


var $9a7dcb914b29cd9f$exports = {};
$9a7dcb914b29cd9f$exports = {
    "close": `Закрыть`,
    "notifications": `Уведомления`
};


var $e43d964a0c7f1266$exports = {};
$e43d964a0c7f1266$exports = {
    "close": `Zatvoriť`,
    "notifications": `Oznámenia`
};


var $0bc56cee3275bcaa$exports = {};
$0bc56cee3275bcaa$exports = {
    "close": `Zapri`,
    "notifications": `Obvestila`
};


var $7dbdd7289c10d2ba$exports = {};
$7dbdd7289c10d2ba$exports = {
    "close": `Zatvori`,
    "notifications": `Obaveštenja`
};


var $ccbe6066c10b1e53$exports = {};
$ccbe6066c10b1e53$exports = {
    "close": `Stäng`,
    "notifications": `Aviseringar`
};


var $9d503476b9d858b7$exports = {};
$9d503476b9d858b7$exports = {
    "close": `Kapat`,
    "notifications": `Bildirimler`
};


var $32ee419c7b9b7a83$exports = {};
$32ee419c7b9b7a83$exports = {
    "close": `Закрити`,
    "notifications": `Сповіщення`
};


var $122525af1cb737c7$exports = {};
$122525af1cb737c7$exports = {
    "close": `关闭`,
    "notifications": `通知`
};


var $52e8b1b00094e5a3$exports = {};
$52e8b1b00094e5a3$exports = {
    "close": `關閉`,
    "notifications": `通知`
};


$7853651519a70071$exports = {
    "ar-AE": $ff9177efc58547ad$exports,
    "bg-BG": $25eb7c0c0c45e544$exports,
    "cs-CZ": $28feffc3d61a8691$exports,
    "da-DK": $390d441203d25ff4$exports,
    "de-DE": $7063c2d0f14f979a$exports,
    "el-GR": $2dfc1dbb6590af88$exports,
    "en-US": $9a12ff1caae5a7a5$exports,
    "es-ES": $f4095fb5a72adbe6$exports,
    "et-EE": $75bc5191b9d7826a$exports,
    "fi-FI": $e4b9aef18b0db8dc$exports,
    "fr-FR": $888756784d832bd7$exports,
    "he-IL": $6835949b68a1fabf$exports,
    "hr-HR": $87ffcbc0b651e40b$exports,
    "hu-HU": $dc6e3b2813600d69$exports,
    "it-IT": $fe136bcbacfcfa14$exports,
    "ja-JP": $8fb53a929b46df83$exports,
    "ko-KR": $2c38dbfaf041a865$exports,
    "lt-LT": $48f3f33a29908d4c$exports,
    "lv-LV": $9867160d996455a0$exports,
    "nb-NO": $196258ea25c96487$exports,
    "nl-NL": $949061cb954e8000$exports,
    "pl-PL": $8189bed27add1ad3$exports,
    "pt-BR": $a361756a93b6e28c$exports,
    "pt-PT": $034c7393857c8db0$exports,
    "ro-RO": $e33d3b3868478b04$exports,
    "ru-RU": $9a7dcb914b29cd9f$exports,
    "sk-SK": $e43d964a0c7f1266$exports,
    "sl-SI": $0bc56cee3275bcaa$exports,
    "sr-SP": $7dbdd7289c10d2ba$exports,
    "sv-SE": $ccbe6066c10b1e53$exports,
    "tr-TR": $9d503476b9d858b7$exports,
    "uk-UA": $32ee419c7b9b7a83$exports,
    "zh-CN": $122525af1cb737c7$exports,
    "zh-TW": $52e8b1b00094e5a3$exports
};





function $d6542812f0669241$export$a407b657d3044108(props, state, ref) {
    let { key: key, timer: timer, timeout: timeout, animation: animation } = props.toast;
    (0, $5bA4N$useEffect)(()=>{
        if (!timer) return;
        timer.reset(timeout);
        return ()=>{
            timer.pause();
        };
    }, [
        timer,
        timeout
    ]);
    // Restore focus to the toast container on unmount.
    // If there are no more toasts, the container will be unmounted
    // and will restore focus to wherever focus was before the user
    // focused the toast region.
    let focusOnUnmount = (0, $5bA4N$useRef)(null);
    (0, $5bA4N$useLayoutEffect)(()=>{
        let container = ref.current.closest("[role=region]");
        return ()=>{
            if (container && container.contains(document.activeElement)) // Focus must be delayed for focus ring to appear, but we can't wait
            // until useEffect cleanup to check if focus was inside the container.
            focusOnUnmount.current = container;
        };
    }, [
        ref
    ]);
    // eslint-disable-next-line
    (0, $5bA4N$useEffect)(()=>{
        return ()=>{
            if (focusOnUnmount.current) focusOnUnmount.current.focus();
        };
    }, [
        ref
    ]);
    let titleId = (0, $5bA4N$useId)();
    let descriptionId = (0, $5bA4N$useSlotId)();
    let stringFormatter = (0, $5bA4N$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($7853651519a70071$exports))));
    return {
        toastProps: {
            role: "alert",
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"] || titleId,
            "aria-describedby": props["aria-describedby"] || descriptionId,
            "aria-details": props["aria-details"],
            // Hide toasts that are animating out so VoiceOver doesn't announce them.
            "aria-hidden": animation === "exiting" ? "true" : undefined
        },
        titleProps: {
            id: titleId
        },
        descriptionProps: {
            id: descriptionId
        },
        closeButtonProps: {
            "aria-label": stringFormatter.format("close"),
            onPress: ()=>state.close(key)
        }
    };
}








function $6cc546b19ee7130a$export$b8cbbb20a51697de(props, state, ref) {
    let stringFormatter = (0, $5bA4N$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($7853651519a70071$exports))));
    let { landmarkProps: landmarkProps } = (0, $5bA4N$useLandmark)({
        role: "region",
        "aria-label": props["aria-label"] || stringFormatter.format("notifications")
    }, ref);
    let { hoverProps: hoverProps } = (0, $5bA4N$useHover)({
        onHoverStart: state.pauseAll,
        onHoverEnd: state.resumeAll
    });
    let lastFocused = (0, $5bA4N$useRef)(null);
    let { focusWithinProps: focusWithinProps } = (0, $5bA4N$useFocusWithin)({
        onFocusWithin: (e)=>{
            state.pauseAll();
            lastFocused.current = e.relatedTarget;
        },
        onBlurWithin: ()=>{
            state.resumeAll();
            lastFocused.current = null;
        }
    });
    // When the region unmounts, restore focus to the last element that had focus
    // before the user moved focus into the region.
    // TODO: handle when the element has unmounted like FocusScope does?
    // eslint-disable-next-line arrow-body-style
    (0, $5bA4N$useEffect)(()=>{
        return ()=>{
            if (lastFocused.current && document.body.contains(lastFocused.current)) {
                if ((0, $5bA4N$getInteractionModality)() === "pointer") (0, $5bA4N$focusWithoutScrolling)(lastFocused.current);
                else lastFocused.current.focus();
            }
        };
    }, [
        ref
    ]);
    return {
        regionProps: (0, $5bA4N$mergeProps)(landmarkProps, hoverProps, focusWithinProps, {
            tabIndex: -1,
            // Mark the toast region as a "top layer", so that it:
            //   - is not aria-hidden when opening an overlay
            //   - allows focus even outside a containing focus scope
            //   - doesn’t dismiss overlays when clicking on it, even though it is outside
            // @ts-ignore
            "data-react-aria-top-layer": true
        })
    };
}




export {$d6542812f0669241$export$a407b657d3044108 as useToast, $6cc546b19ee7130a$export$b8cbbb20a51697de as useToastRegion};
//# sourceMappingURL=module.js.map
